export class Pagination {
    pageCount: number;
    itemCountPerPage: number;
    first: number;
    current: number;
    last: number;
    pagesInRange: any;
    firstPageInRange: number;
    lastPageInRange: number;
    currentItemCount: number;
    totalItemCount: number;
    firstItemNumber: number;
    lastItemNumber: number;

    constructor(init?: Partial<Pagination>) {
        Object.assign(this, init);
    }
}
